import * as Api from '../API/API.js';

import Modal from "react-bootstrap/Modal";
import floreimg from '../Images/ic_flore.png'
import * as Helpers from '../Helpers/helpersFunc.js';
import ExitButton from './ExitButton'


function FloreModal(props){

    

    const handleClose = () => props.setVisibleModalType(4);

    

    const _displayImage = () => {
      return(
        <img className="modalPhoto" src={Api.getImage(props.infos.picture)} alt="" ></img> 
      )
    }

    const _displayIdentifications = (identifications) => {
      return(
        Object.keys(identifications).map((key, index) => { 
          if(identifications[key]){
            return(

              <div key={key} className="row ">

                <div className="col-5 idtitle">Identification {key}</div>
                <div className="col-1">|</div>
                <div className="col-6">{identifications[key]}</div>
              </div>
              
            ) 
          }      
        })  
      )
    }

    const _displayGrade = (grade) => {
      return(
       

              <div className="row ">

                <div className="col-5 idtitle">Note de confiance</div>
                <div className="col-1">|</div>
                <div className="col-6">{grade} / 5</div>
              </div>
              
           
      )
    }

    
    return(
        <Modal show={props.visible} onHide={handleClose}
        size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
  <Modal.Header className="floreModalHeader text-center">
    <Modal.Title className="floreModalTitle w-100"><div className="row"><div className="col-md-1 col-2 col-sm-2"></div><div className="col-md-10 col-8 col-sm-8"><img className="modalicon" src={floreimg} alt="" ></img></div><div className="col-md-1 col-2 col-sm-2"><ExitButton closeFunc={handleClose}/></div></div></Modal.Title>
  </Modal.Header>

  <Modal.Body>
  <div className="row">

  <div className="col-md-4 col-12 col-sm-12 text-center photoCol">{props.infos.picture && _displayImage()}</div>
  

  <div className="col-md-8 col-12 col-sm-12 contentCol">
    
    <div className="obsName">{props.infos.name}</div>
    <div className="obsObserver">{props.infos.observer}</div>
    <div className="obsDate">{Helpers.isoStringToDateString(props.infos.date)}</div>

    <div className="obsDesc ">{props.infos.description}</div>

    <div className=" obsId">{"imageIdentification" in props.infos && _displayIdentifications(props.infos.imageIdentification)}</div>
    <div className=" obsId">{_displayGrade(props.infos.confidenceGrade)}</div>

</div>


</div>
    
  </Modal.Body>

  
</Modal>
    )
}

export default FloreModal;